module.exports = __webpack_public_path__ + "media/v_kebab_ua.c6cfc1f1.mp4";